import React, { Suspense } from 'react';
import { useSelector } from 'react-redux';
import { Route, Switch, useLocation } from 'react-router-dom';
import queryString from 'query-string';
import '../../scss/custRequestComm.scss';
import '../../scss/style.scss';
import AgreePage from '../../views/custRequest/agreePage';
import ApoCntrFormPage from '../../views/custRequest/apoCntrFormPage';
import ApoDocFormPage from '../../views/custRequest/apoDocFormPage';
import Error from '../../views/custRequest/comm/Error';
import InCarAgreePage from '../../views/custRequest/inCar/agreePage';
import InCarApoDocFormPage from '../../views/custRequest/inCar/apoDocFormPage';
import InCarInfoPage from '../../views/custRequest/inCar/infoPage';
import InCarInsertPage from '../../views/custRequest/inCar/insertPage';
import InCarMainPage from '../../views/custRequest/inCar/mainPage';
import InCarSbmsDocPage from '../../views/custRequest/inCar/sbmsDocPage';
import InCarApoCntrFormPage from '../../views/custRequest/inCar/apoCntrFormPage';
import InCarSubmissionPage from '../../views/custRequest/inCar/submissionPage';
import InfoPage from '../../views/custRequest/infoPage';
import InsertPage from '../../views/custRequest/insertPage';
import MainPage from '../../views/custRequest/mainPage';
import SbmsDocPage from '../../views/custRequest/sbmsDocPage';
import SubmissionPage from '../../views/custRequest/submissionPage';
import CmplPage from '../../views/custRequest/cmplPage';
import InCarCmplPage from '../../views/custRequest/inCar/cmplPage';

const UserLayout = () => {
  const loading = (
    <div className="pt-3 text-center">
      <div className="sk-spinner sk-spinner-pulse" />
    </div>
  );

  // const state = useSelector((reduxState) => reduxState.main);
  // const pathName = useLocation().pathname;
  // const pathLength = useLocation().pathname.split('/').length;
  // let path = useLocation().pathname.substring(1).toLowerCase();
  let path = useLocation().pathname.split('/')[1];
  // const query = queryString.parse(location.search);
  // const reqNo = query.reqNo;
  
  // console.log(path);
  // console.log(query);
  // console.log(reqNo);
  // console.log(match);

  // if (pathName !== '/' && pathLength > 2) path = state.corpNm.toLowerCase();

  return (
    <>
      <div className="c-app c-default-layout">
        <div className="c-wrapper">
          <div className="c-body">
            <Suspense fallback={loading}>
              <Switch>
                <Route
                  exact
                  path={`/${path}`}
                  render={(props) => (path === 'incar' ? <InCarMainPage {...props} /> : <MainPage {...props} />)}
                  // render={(props) => (path === 'incarfs' ? <InCarMainPage {...props} /> : <MainPage {...props} />)}
                />
                <Route
                  exact
                  path={`/${path}/1`}
                  render={(props) => (path === 'incar' ? <InCarInfoPage {...props} /> : <InfoPage {...props} />)}
                  // render={(props) => (path === 'incarfs' ? <InCarInfoPage {...props} /> : <InfoPage {...props} />)}
                />
                <Route
                  exact
                  path={`/${path}/2`}
                  render={(props) => (path === 'incar' ? <InCarAgreePage {...props} /> : <AgreePage {...props} />)}
                  // render={(props) => (path === 'incarfs' ? <InCarAgreePage {...props} /> : <AgreePage {...props} />)}
                />
                <Route
                  exact
                  path={`/${path}/3`}
                  render={(props) => (path === 'incar' ? <InCarSbmsDocPage {...props} /> : <InsertPage {...props} />)}
                  // render={(props) => (path === 'incarfs' ? <InCarSbmsDocPage {...props} /> : <InsertPage {...props} />)}
                />
                <Route
                  exact
                  path={`/${path}/4`}
                  render={(props) => (path === 'incar' ? <InCarInsertPage {...props} /> : <ApoCntrFormPage {...props} />)}
                  // render={(props) => (path === 'incarfs' ? <InCarInsertPage {...props} /> : <ApoCntrFormPage {...props} />)}
                />
                <Route
                  exact
                  path={`/${path}/5`}
                  render={(props) => (path === 'incar' ? <InCarApoCntrFormPage {...props} /> : <ApoDocFormPage {...props} />)}
                  // render={(props) => (path === 'incarfs' ? <InCarApoCntrFormPage {...props} /> : <ApoDocFormPage {...props} />)}
                />
                <Route
                  exact
                  path={`/${path}/6`}
                  render={(props) => (path === 'incar' ? <InCarApoDocFormPage {...props} /> : <SbmsDocPage {...props} />)}
                  // render={(props) => (path === 'incarfs' ? <InCarApoDocFormPage {...props} /> : <SbmsDocPage {...props} />)}
                />
                <Route
                  exact
                  path={`/${path}/7`}
                  render={(props) => (path === 'incar' ? <InCarSubmissionPage {...props} /> : <SubmissionPage {...props} />)}
                  // render={(props) => (path === 'incarfs' ? <InCarSubmissionPage {...props} /> : <SubmissionPage {...props} />)}
                />
                <Route
                  exact
                  path={`/${path}/8`}
                  render={(props) => (path === 'incar' ? <InCarCmplPage {...props} /> : <CmplPage {...props} />)}
                  // render={(props) => (path === 'incarfs' ? <InCarCmplPage {...props} /> : <CmplPage {...props} />)}
                />
                <Route
                  path='*'
                  render={props => <Error {...props} />}
                />
              </Switch>
            </Suspense>
          </div>
        </div>
      </div>
    </>
  );
};

export default UserLayout;
